import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

import { CalendarClient } from '@lyrahealth-inc/ui-core-crossplatform/src/ui-models/clients/CalendarClient'

import { getClients } from '../../../../clients/data/clientsDataActions'
import { getClientsDataClientList } from '../../../../clients/data/clientsDataSelectors'
import { MILITARY_ONE_SOURCE_EMPLOYER } from '../../../../common/constants/appConstants'
import { getAuthUserId } from '../../../../data/auth/authSelectors'
import { useAppDispatch } from '../../../../data/store'

export const useLegacyCalendarClients = ({ enabled }: { enabled: boolean }) => {
  const dispatch = useAppDispatch()
  const userId = useSelector(getAuthUserId)
  const clients = useSelector(getClientsDataClientList)
  const [isLoading, setIsLoading] = useState(enabled)

  useEffect(() => {
    if (!enabled || !userId) {
      return
    }
    setIsLoading(true)
    Promise.resolve(dispatch(getClients(userId)))
      .catch((err) => {
        console.error('useLegacyCalendarClients: failed to fetch legacy clients', err)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [dispatch, enabled, userId])

  const allClients = useMemo<CalendarClient[]>(() => {
    if (!enabled) {
      return []
    }
    return (
      clients
        ?.filter((client) => client.employer === MILITARY_ONE_SOURCE_EMPLOYER)
        .map((client) => ({
          id: client.id,
          name: `${client.preferred_first_name ?? client.first_name} ${client.preferred_last_name ?? client.last_name}`,
          legalFirstName: client.first_name,
          legalLastName: client.last_name,
        })) ?? []
    )
  }, [clients, enabled])

  return {
    suggestedClients: [] as CalendarClient[],
    clients: allClients,
    allClients,
    isLoading,
  }
}
